import React from 'react';
import classNames from 'classnames';
import kebabCase from 'lodash/kebabCase';

export const WidgetCard = ({ children, sentiment, reverse, className }) => {
  return (
    <div
      className={classNames('widget-card', className, {
        [`widget-card-${kebabCase(reverse ? `-${sentiment}-reverse` : sentiment)}`]:
          sentiment,
      })}
    >
      {children}
    </div>
  );
};
